import { Injectable } from '@angular/core';

import { SessionStorageService } from '../../../../core';

import { ClienteVisualizacao } from './cliente-visualizacao';

/**
 * Service utilizado para armazenar os dados de visualização dos clientes no session storage do navegador
 */
@Injectable({
    providedIn: 'root'
})
export class ClienteVisualizacaoStorageService {
    constructor(private sessionStorageService: SessionStorageService) { }

    /** Obtem o storage da visualização de clientes no Session Storage do navegador */
    get(key: string): ClienteVisualizacao {
        const storage = this.sessionStorageService.getObject(key);
        if (!storage) {
            return new ClienteVisualizacao();
        }
        return storage as ClienteVisualizacao;
    }

    /** Seta o storage da visualização de clientes no Session Storage do navegador */
    set(key: string, storage: ClienteVisualizacao) {
        this.sessionStorageService.setObject(key, storage);
    }

    /** Remove o storage da visualização de clientes no Session Storage do navegador */
    remove(key: string) {
        this.sessionStorageService.remove(key);
    }
}
